<div class="flex flex-col space-y-[1rem]">
  <div class="flex justify-between">
    <app-button
      data-qa="back-button"
      [type]="'grey'"
      [size]="'small'"
      [iconName]="'left-arrow.svg'"
      (buttonClick)="backToPrevUrl()">
      Back
    </app-button>
    <app-button
      data-qa="add-period-button"
      [type]="'grey-accent'"
      [size]="'small'"
      [iconName]="'plus.svg'"
      (buttonClick)="show.modal.copyFp = true">
      Period
    </app-button>
  </div>

  <div class="vertical-container-simple column-gap-1p25">
    <div *ngIf="(fundPerformances?.length || isAdmin) && selected.fp" class="main">
      <div
        data-qa="open-close-value-creation-charts"
        class="start-row-container row-gap-0p625 clickable"
        (click)="show.valueCreationCharts = !show.valueCreationCharts">
        <app-table-group-icon [opened]="show.valueCreationCharts"></app-table-group-icon>
        <span class="bold600 font-2">Value creation charts</span>
      </div>
      <app-value-creation-charts *ngIf="show.valueCreationCharts"></app-value-creation-charts>
    </div>
    <div *ngIf="tabs" class="main column-gap-1">
      <app-tabs
        [tabNamesRaw]="tabs.dataBehind.all"
        [selectedIndexTab]="tabs.dataBehind.all.indexOf(tabs.dataBehind.selected)"
        [type]="'underlined'"
        (selectedTabEmitter)="tabs.dataBehind.selected = $event"
      />
      <ng-container [ngSwitch]="tabs.dataBehind.selected">
        <app-fund-performance-high-level-table
          *ngSwitchCase="'Fund performance'"
          class="green-scroll"
          [fundPerformances]="fundPerformances"
          [isAdmin]=isAdmin
          [switcher]="switcher"
          [hideDistribution]="show.distribution"
          [selectedOrganization]="selected.org"
          (showModalEmitter)="parseShowModal($event)"
          (periodEmitter)="parsePeriodEmitter($event)"
        />

        <app-fund-performance-active-table
          *ngSwitchCase="'Portfolio details'"
          class="green-scroll"
          [fundPerformances]="fundPerformances"
          [selectedFund]="selected.org?.selectedFund"
          [switcher]="switcher"
          (changePeriod)="changePeriod($event)"
        />

        <app-fund-performance-net-irr
          *ngSwitchCase="'Net IRR'"
          class="green-scroll"
          (updateFPs)="closeModalAfterUpdate($event)"
        />
      </ng-container>
    </div>
  </div>
</div>

<app-modal-fp-bulk-upload-wrapper
  *ngIf="show.modal.bulkUpload"
  (closeEmitter)="show.modal.bulkUpload = false"
/>

<app-modal-fund-performance-update
  *ngIf="show.modal.fpUpdate"
  [selected]="selected"
  [fundPerformanceList]="fundPerformances"
  (fundPerfSetter)="updateFpFromModal($event)"
  (isConfirmedUpdate)="closeModalAfterUpdate($event)"
  (deleteFundPerformance)="showModalForDeleteFP($event)"
/>

<app-modal-dialog
  *ngIf="show.modal.fpDelete"
  [header]="'Delete period'"
  [useStandardList]="false"
  [mainText]="textListDeletePeriod"
  (isConfirmed)="deleteFundPerformance($event)"
/>

<app-modal-copy-period
  *ngIf="show.modal.copyFp"
  [selectedFundUuid]="selected.org.selectedFund.uuid"
  [selectedPeriod]="selected.period"
  [periods]="selected.periods"
  (emitter)="copyPeriod($event)"
/>
